export interface CostType {
  id: string;
  description: string;
  chargeType: ChargeType;
  appliedPer: AppliedPer;
  chargePeriod: ChargePeriod;
  defaultPrice: number;
  onDashboard: boolean;
  notInUse: boolean;
}

export interface AdditionalCost {
  id: string;
  additionalCostTypeId: string;
  price: number;
  startDateTime: string;
  endDateTime?: string;
  deleted: boolean;
  notes: string;
  changed: boolean;
  error: boolean;
  appliedPer: AppliedPer;
  chargePeriod: ChargePeriod;
  chargeType: ChargeType;
}

export enum ChargeType {
  LOT = 1,
  GROUP = 2,
}

export enum AppliedPer {
  ANIMAL = 1,
  LOT = 2,
  GROUP = 3,
}

export enum ChargePeriod {
  DAY = 1,
  ON_SPECIFIC_TIMESTAMP = 2,
}
